// Assembles the per-feature namespace modules into the two locale message
// trees vue-i18n expects: { en: { <ns>: {...} }, cs: { <ns>: {...} } }.
//
// Each namespace module lives in ./namespaces/<name>.ts and exports a default
// object shaped { en: {...}, cs: {...} } so a translator sees both languages
// side by side. Add a namespace here once and it is available app-wide as
// t('<name>.<key>').

import common from './namespaces/common';
import nav from './namespaces/nav';
import footer from './namespaces/footer';
import cookie from './namespaces/cookie';
import auth from './namespaces/auth';
import home from './namespaces/home';
import catalog from './namespaces/catalog';
import product from './namespaces/product';
import cart from './namespaces/cart';
import checkout from './namespaces/checkout';
import orders from './namespaces/orders';
import favorites from './namespaces/favorites';
import account from './namespaces/account';
import help from './namespaces/help';
import articles from './namespaces/articles';
import legal from './namespaces/legal';
import errors from './namespaces/errors';
import search from './namespaces/search';

const namespaces = {
  search,
  common,
  nav,
  footer,
  cookie,
  auth,
  home,
  catalog,
  product,
  cart,
  checkout,
  orders,
  favorites,
  account,
  help,
  articles,
  legal,
  errors,
};

type NamespaceMap = typeof namespaces;
type LocaleTree = { [K in keyof NamespaceMap]: NamespaceMap[K]['en'] };

const buildTree = (locale: 'en' | 'cs'): LocaleTree =>
  Object.fromEntries(
    Object.entries(namespaces).map(([name, mod]) => [name, mod[locale]]),
  ) as LocaleTree;

export const messages = {
  en: buildTree('en'),
  cs: buildTree('cs'),
};
